import script from "./FinanceProjectionRiskCard.vue?vue&type=script&setup=true&lang=js"
export * from "./FinanceProjectionRiskCard.vue?vue&type=script&setup=true&lang=js"

import "./FinanceProjectionRiskCard.vue?vue&type=style&index=0&id=2226e4ed&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2226e4ed"]])

export default __exports__